import humanizeString from 'humanize-string'

import { getAttemptsStatus } from '@new/domains/operations/utils/sendAttempts'

import { GuestInboxSend } from '../StayTimeline.types'
import { Pill } from './Shared.styles'

interface SendStatusPillProps {
  send: GuestInboxSend
  attempts?: number
}

export const SendStatusPill = ({ send, attempts = 1 }: SendStatusPillProps) => (
  <Pill $tone={send.failed ? 'bad' : 'good'}>
    {getAttemptsStatus({ attempts, status: humanizeString(send.status), isFailed: send.failed })}
  </Pill>
)
